<template>
    <div style="box-shadow: 0px 0px 4px #999999 ;">

        <div style="padding: 15px">
            <div>
<!--                <van-cell style="padding-left: 0px">-->
<!--                    <van-image slot="icon" :src="shareIcon" round style="width: 40px; height: 40px; margin-right: 8px;" />-->
<!--                    <div slot="title" style="font-size: 15px; font-weight: bold;height: 40px;display: table-cell; vertical-align: middle">-->
<!--                        {{shareTitle}}-->
<!--                    </div>-->
<!--                </van-cell>-->
                <div v-if="shareImg && shareImg.length > 0 && shareImg[0].img">
                    <van-row>
                        <van-col span="3" style="">
                            <Wp_image v-if="shareIcon" url="/images/wanpinjingxuan_logo_01.png" :radius="20" style="width: 40px; height: 40px;" />
                        </van-col>
                        <van-col span="21">
                            <div style="font-size: 16px; font-weight: bold;height: 40px; line-height: 20px; display: table-cell; vertical-align: middle">
<!--                                {{shareTitle ? shareTitle : "京选小助手"}}-->
                                京选小助手
                                <br>
                                <span style="font-size: 12px; font-weight: normal;">{{shareTime}}</span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div v-else>
                    <div style="text-align: center; font-size: 17px; font-weight: bold; margin-bottom: 10px">
                        {{shareTitle}}
                    </div>
                </div>

            </div>

            <div v-if="shareImg && shareImg.length > 0 && shareImg[0].img">
                <div style="padding-top: 15px">
                    <div v-if="!shareContent" style="padding-left: 5px">
                        <van-loading type="spinner" color="#1989fa" size="20">
                            <div slot="default" style="color: #1989fa;font-size: 15px;">
                                文案生成中...
                            </div>
                        </van-loading>
                    </div>

                    <div :class="content_class_name" v-html="shareContent">
                    </div>
                    <div style="text-align: center; padding-top: 5px; " @click="showAllContent">
                        <van-icon :name="icon_arrow_name" size="15" color="#1989fa"></van-icon>
                    </div>
                </div>

                <div style="margin-top: 10px">
<!--                    <div v-if="shareImg.length === 1">-->
<!--                        <Wp_image v-if="shareImg[0].img" slot="icon" :url="shareImg[0].img"-->
<!--                                  style="width: 120px; height: 120px; margin-top: 5px;"-->
<!--                                  @click="saveImg"/>-->
<!--                    </div>-->
<!--                    <div v-else-if="shareImg.length > 1">-->
<!--                        <Wp_img_swipe :list="shareImg" width="120px" height="120px" @clickImage="saveImg"></Wp_img_swipe>-->
<!--                    </div>-->

                    <van-grid :column-num="3" :border="false" >
                        <van-grid-item
                                v-for="(item, index) in shareImg"
                                :key="index"
                                @click="clickItem(item, index)"
                        >
                            <Wp_image v-if="item.img" slot="icon" :url="item.img"
                                      @click="saveImg"/>

                        </van-grid-item>
                    </van-grid>

                    <div style="text-align: right; margin-top: 5px">
                        <van-button type="danger"
                                    round
                                    size="small"
                                    plain
                                    :disabled="!shareContent"
                                    style="padding: 0px 15px"
                                    v-clipboard:copy="shareContent.replace(new RegExp('<br/>','g'), '\n')"
                                    v-clipboard:success="onCopySuccess"
                                    v-clipboard:error="onError">
                            复制文字
                        </van-button>
                        <van-button type="danger"
                                    round
                                    size="small"
                                    style="padding: 0px 15px; margin-left: 5px"
                                    @click="saveImg">
                            保存图片
                        </van-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="content_all" v-html="shareContent">
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { ImagePreview, Dialog } from 'vant';

    import Wp_image from "./Wp_image";

    Vue.use(ImagePreview);

    export default {
        name: "Wp_jd_share_with_link_model",
        components: {Wp_image},
        props:{
            shareData: {type: Object},
            // shareIcon: {type: String, default: "/images/wanpinjingxuan_logo_01.png"},
            // shareTitle: {type: String, default: ""},
            // shareContent: {type: String, default: ""},
            // shareImg: {type: Array},
        },

        data(){
            return{

                showLoading: false,

                icon_arrow_name: "arrow-down",
                field_auto_size: {maxHeight: 180, minHeight: 50},

                content_class_name: "content_line_8",

                shareIcon: "/images/wanpinjingxuan_logo_01.png",
                shareTitle: "",
                shareContent: "",
                shareImg: [],

                shareTime: "",

        // :share-title="item.act_name"
        // :share-content="item.act_content"
        // :share-img="[{img: item.act_share_img}, {img: item.act_share_img}]"
            }
        },

        created(){
            this.initDatas();
        },

        methods:{

            initDatas(){
                if(this.shareData){
                    this.shareTitle = this.shareData.act_name;
                    this.shareImg = [{img: this.shareData.act_share_img}];

                    if(this.shareData.act_share_list && this.shareData.act_share_list.length > 0){
                        this.shareImg = [];
                        for(let i = 0; i < this.shareData.act_share_list.length; i++){
                            let item = {
                                img: this.shareData.act_share_list[i].url,
                                type: this.shareData.act_share_list[i].type
                            };
                            this.shareImg.push(item);
                        }
                    }

                    this.shareTime = this.shareData.createtime;

                    this.initActionContentAndLink(this.shareData.act_content, newContent=>{
                        this.shareContent = this.formatContent(newContent);
                    })
                }
            },

            initActionContentAndLink(content, fn) {
                if (content) {
                    if(content.indexOf("http") !== -1){
                        this.showButtons = true;
                        let params = {
                            content: content,
                            pid: this.$common.getUsername(),
                            hard: "yes"
                        };

                        this.$getChangeLink(params, response => {

                            if (response && response.code === 200) {

                                if(fn){
                                    fn(response.content);
                                }

                            } else if (response.code === 0) {
                                this.$dialog.alert({
                                    message: '文案生成暂无响应'
                                });
                            } else if (response.code >= 500) {
                                // Dialog.alert({
                                //     message: response.message
                                // })
                                if(response.message && response.message.indexOf("pid") !== -1
                                    && this.$config.project === 'mini'){

                                    this.$dialog.alert({
                                        message: "该活动仅限超级会员，您可完成超级会员任务，并升级为超级会员"
                                    }).then(()=>{
                                        this.$common.switchTabMiniProgramPage("../wp_guide/wp_guide")
                                    });
                                }else if(response.temp === 500 && response.message){//temp为pid为空时的自定义
                                    this.$dialog.alert({
                                        message: "该活动仅限超级会员，您可完成超级会员任务，并升级为超级会员"
                                    }).then(()=>{
                                        // this.$common.switchTabMiniProgramPage("../wp_select/wp_select")
                                        this.$router.back();
                                    });
                                }else{
                                    this.$dialog.alert({
                                        message: response.message,
                                    })
                                }

                            } else if (response.toString().indexOf('Error') != -1) {
                                if (response.toString().indexOf('timeout') != -1) {
                                    this.$dialog.alert({
                                        message: '文案生成超时，请返回重试'
                                    });
                                } else {
                                    this.$dialog.alert({
                                        message: '文案生成错误，请返回重试'
                                    });
                                }
                            }else{
                                this.$dialog.alert({
                                    title: "文案生成失败",
                                    message: response.message
                                });
                            }

                        })
                        // setTimeout(() => {
                        //     this.loading_text = "转链操作较为耗时，请耐心等待..."
                        // }, 5000);
                    }else{
                        this.showButtons = false;
                        if(fn){
                            fn(content);
                        }
                    }


                    // this.show_paste_sheet_model = false;


                }
            },

            showAllContent(){
                if(this.icon_arrow_name === "arrow-down"){
                    this.icon_arrow_name = "arrow-up";
                    this.content_class_name = "content_all"
                }else{
                    this.icon_arrow_name = "arrow-down";
                    this.content_class_name = "content_line_8"
                }
            },

            clickItem(item, index){
                if(item){
                    ImagePreview({
                        images: this.getImages(this.shareImg),
                        startPosition: index,
                    });
                }else{
                    this.$toast.fail({
                        message: "无图片数据"
                    })
                }
            },

            saveImg(){
                if(this.shareImg && this.shareImg.length > 0){
                    ImagePreview({
                        images: this.getImages(this.shareImg),
                    });
                }else{
                    this.$toast.fail({
                        message: "无图片数据"
                    })
                }
            },

            getImages(_images){

                let imgs = [];
                for(let i = 0; i < _images.length; i++){
                    imgs.push(_images[i].img)
                }
                return imgs;
            },

            // makePoster(){
            //
            //     this.showLoading = true;
            //     this.getQrcodeUrl(()=>{
            //
            //         this.wx_user_info = this.$common.gloabl_wx_mini_user_info;
            //
            //         if(this.qrcodeImgUrl){
            //             let timestamp = "_" + Date.parse(new Date());
            //             this.show_share_pop = timestamp;
            //         }
            //         this.showLoading = false;
            //     })
            // },
            //
            // getQrcodeUrl(fn){
            //     if(this.$common.gloabl_wx_mini_qr_img){
            //         this.qrcodeImgUrl = this.$common.gloabl_wx_mini_qr_img;
            //         if(fn){
            //             fn();
            //         }
            //     }else{
            //         if(this.$common.gloabl_wx_mini_user_info){
            //             let u_code = this.$common.gloabl_wx_mini_user_info.u_code;
            //             let params = {
            //                 app_id: this.$common.wx_app_id,
            //                 app_secret: this.$common.wx_app_secret,
            //                 scene: u_code,
            //                 width: 300
            //             };
            //             this.$getWxAppQrcode(params, response =>{
            //                 this.$log(response)
            //                 if(response && response.data){
            //                     let qr_img_url = response.data;
            //                     if (qr_img_url) {
            //                         this.qrcodeImgUrl = qr_img_url;
            //                         this.$common.gloabl_wx_mini_qr_img = qr_img_url;
            //
            //                         if(fn){
            //                             fn();
            //                         }
            //                     }
            //                 }else{
            //                     this.showLoading = false;
            //                     this.$dialog.alert({
            //                         message: "邀请海报制作失败，请重试"
            //                     })
            //                 }
            //             })
            //         }else{
            //
            //         }
            //     }
            //
            //
            // },

            onCopySuccess() {

                // setTimeout(() => {
                //     this.$notify({
                //         message: '\n复制成功\n ',
                //         duration: 2000,
                //         background: '#1989fa'
                //     });
                //
                // }, 500);
                this.$toast.success({
                    message: "复制成功"
                })

            },

            onError() {

                // setTimeout(() => {
                //     this.$notify({
                //         message: '\n复制失败\n ',
                //         duration: 2000,
                //     });
                // }, 500);
                this.$toast.fail({
                    message: "复制失败"
                })
            },

            /**
             * 导航返回键
             */
            onClickBack(){
                this.$router.back();
            },

            formatContent(content){
                if(content){
                    return content.replace(new RegExp('\\n','g'), '<br/>');
                }
            },
        }
    }
</script>

<style scoped>
    .content_line_8{
        /*margin-top: 3px;*/
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 8;
    }

    .content_all{
        /*margin-top: 3px;*/
        font-size: 15px;
        /*overflow: hidden;*/
        /*text-overflow: ellipsis;*/
        /*display: -webkit-box;*/
        /*-webkit-box-orient: vertical;*/
        /*-webkit-line-clamp: 5;*/
    }

    /deep/ .van-grid-item .van-grid-item__content  {
        background-color: rgba(255, 255, 0, 0);
        padding: 5px;
    }

</style>